export default "__VITE_ASSET__CTYZIYsy__"